import { ExamSubject } from 'generated/graphql'

export interface SubjectTabType {
  id: string
  label: string
}

export const GSAT_SUBJECT_TAB_LIST: SubjectTabType[] = [
  { id: ExamSubject.MATH, label: '수리 영역' },
  { id: ExamSubject.REASONING, label: '추리 영역' },
]
